

























































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import Moment from 'moment'
import { NumberMixin, DateMixin } from '@finx/web-repository/src/mixin/_'
import { Factories } from '@finx/web-repository'
import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'
import MedicoStore from '@/store/relatorio/medico/medico'
import StoreRelatorios from '@/store/Relatorios'

@Component({
  mixins: [DateMixin, NumberMixin],
})

export default class ComponentRelatorioListagem extends Vue {
  @Prop(String) dataSelecionada
  @Prop(Object) loadings
  @Prop(Object) period
  @Prop(Object) relatorio
  @Prop(String) typeReport

  data() {
    return {
      total: 0,
      lista: [],
      start: 0,
      end: 0,
    }
  }

  detalhe(idFontePagadora, idOperadora) {
    // @ts-ignore
    if (this.typeReport === 'fonte-pagadora') this.$router.push(`/relatorio/detalhe/fonte-pagadora/${idFontePagadora}/operadora/${idOperadora}/${this.start}/${this.end}`)
  }

  formatarValor(valor) {
    // @ts-ignore
    return `R$ ${this.formatDecimalNumber(valor, 2, '.', ',')}`
  }

  formatarNumero(valor) {
    // @ts-ignore
    return this.formatIntegerNumber(valor, ',')
  }

  colorirLinha(index) {
    return (index % 2 !== 0) ? 'background-color: #f5f7f5;' : null
  }

  @Emit('getRelatorio')
  getRelatorio() {}
}
